/* @flow */
import React from 'react';
import gql from 'graphql-tag';
import {
    GlobalInlineAlert,
    globalInlineAlertFragments
} from '@homeaway/react-global-messaging';
import {EdapProvider} from '@homeaway/react-event-tracking';

type Props = {
    globalMessages?: mixed
};

export const fragments = {
    SearchResult: gql`
        fragment GlobalInlineMessageSearchResult on SearchResult {
            globalMessages {
                ...GlobalInlineAlertGlobalMessages
            }
        }
        ${globalInlineAlertFragments.GlobalMessages}
    `
};

export function GlobalInlineMessage({globalMessages}: Props) {
    return (
        <EdapProvider>
            <div data-wdio="GlobalInlineMessage">
                <GlobalInlineAlert globalMessages={globalMessages} />
            </div>
        </EdapProvider>
    );
}
